import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { loginService } from '../services/Login.service';
import type { TAbcloudzLoginCredentials } from '../models/login.model';

class LoginMutation {
  public login$ = tanstackQueryService.mutation({
    mutationFn: ({ dto, silent }: { dto: TAbcloudzLoginCredentials; silent?: boolean }) =>
      loginService.abcloudzLogin(dto, silent)
  });
}

const loginMutation = new LoginMutation();

export { loginMutation };
